import { sortBy } from 'lodash';
import moment from 'moment';

const getTotalDays = (dates = []) => {
  if (!dates.length) {
    return 0;
  }

  const today = moment().format('YYYY-MM-DD');
  const sortedDates = sortBy(dates, 'startDate', 'endDate');

  const formattedIntervals = sortedDates.map(pos => {
    const startDate = pos.startDate;
    const endDate = !pos.endDate ? today : pos.endDate;
    return {
      startDate,
      endDate: moment(endDate).isAfter(today) ? today : endDate,
    };
  });

  const finalIntervals = [];
  formattedIntervals.forEach(interval => {
    if (!finalIntervals.length) {
      finalIntervals.push(interval);
      return;
    }

    const index = finalIntervals.findIndex(({ startDate, endDate }) =>
      moment(interval.startDate).isBetween(startDate, endDate, undefined, '[]'),
    );
    if (index > -1) {
      const originalEndDate = finalIntervals[index].endDate;
      finalIntervals[index].endDate = moment(interval.endDate).isAfter(
        originalEndDate,
      )
        ? interval.endDate
        : originalEndDate;
      return;
    }

    const lastFinalInterval = finalIntervals[finalIntervals.length - 1];
    if (
      moment(interval.startDate).isSame(lastFinalInterval.endDate, 'month') &&
      moment(interval.startDate)
        .subtract(1, 'day')
        .isSame(lastFinalInterval.endDate)
    ) {
      finalIntervals[finalIntervals.length - 1].endDate = interval.endDate;
      return;
    }

    finalIntervals.push(interval);
  });

  const total = finalIntervals
    .map(({ startDate, endDate }) => moment(endDate).diff(startDate, 'days'))
    .reduce(
      (totalDays, totalOfDaysInInterval) => totalDays + totalOfDaysInInterval,
      0,
    );
  return total;
};

export default getTotalDays;
